import React, { useContext, useState } from "react";
import { SettingsContext } from './AccountSettingsButton';
import jsDig from "utils/jsDig.js";
import CustomTooltip from "utils/CustomTooltip";
import { Modal } from 'react-bootstrap';
import showAlert from "utils/showAlert";

export default function LastDataPullStatus(props) {
  const context = useContext(SettingsContext);
  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => setShowModal(!showModal);

  let errorIcon = require("images/lite/icons/alert-circle.svg");
  errorIcon = <img className="data-pull-error-icon filter-red" style={{ width: "32px", cursor: "pointer" }} src={`/datapulse${errorIcon}`} onClick={toggleModal} />;
  let successIcon = require("images/lite/icons/check.svg");
  successIcon = <img className="data-pull-success-icon filter-green" style={{ width: "32px" }} src={`/datapulse${successIcon}`} />;

  const errors = context.data_pull_errors ? context.data_pull_errors.filter((error) => error.platform == props.platform) : [];
  const active = context.active_datasources.includes(props.platform);

  const formatErrorDate = (dateString) => {
    const date = new Date(dateString);

    // Format the date into a readable format in the user's local timezone
    const formattedDate = date.toLocaleString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true  // Use 12-hour time with AM/PM
    });

    return formattedDate;
  }

  const fourDaysAgo = new Date();
  fourDaysAgo.setDate(fourDaysAgo.getDate() - 4);
  
  const uniqueMessages = new Set();
  
  const filteredErrors = errors
    .filter(error => new Date(error.created_at) >= fourDaysAgo) // Remove errors older than 4 days
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)) // Sort by most recent created_at
    .filter(error => {
      const messageWithoutId = error.message.replace(/\(\s*fbtrace_id:\s*[A-Za-z0-9_-]+\s*\)/, '').trim();
      if (uniqueMessages.has(messageWithoutId)) {
        return false;
      } else {
        uniqueMessages.add(messageWithoutId);
        return true;
      }
    });

    
  
  return (
    <div className="last-data-pull-status">
      {filteredErrors.length > 0 ? (
        <CustomTooltip
          img={errorIcon}
          message="Click to see error details"
          inline={true}
        />
      ) : (
        active ? (
          successIcon
        ) : (
          <CustomTooltip
            faClass="fas fa-cogs"
            message="Configuration still required. Data source is not active yet or has not pulled data in the last 60 days. Finish configuration then save and pull data."
            inline={true}
          />
        )
      )}

      <Modal show={showModal} onHide={toggleModal} className="data-pull-error-modal">
        <Modal.Header closeButton>
          <Modal.Title>
            <h4>Data Pull Errors</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {filteredErrors.length > 0 ? (
            filteredErrors.map((error, index) => (
              <div key={index} className="data-pull-error">
                <span>{formatErrorDate(error.created_at)} - {error.message}</span>
              </div>
            ))
          ) : (
            <p>No errors.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button className="lite-btn btn-default mr-3 mt-4" onClick={toggleModal}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
